export enum UserDefinedInformationWindowKinds {
  Normal = 1,
  CScanIntroductionOrigin = 2,
}
